<template>
  <section>
    <div :style="{borderColor: $store.getters.clientStyle.primary, opacity: doesNotApply ? .3 : 1 }"
      class="global-question-card container global-question-card-padding"
      @mouseover="comment.questionIsFocussed=true"
      @mouseleave="() => {if (questionData.comment==1) this.$refs.commentBox.leaveComment()}">

      <!-- Component for question title, description, number and required indicator -->
      <question-header />

      <!-- Specific markup for this question type -->
      <div class="columns global-answer-padding">

        <!-- The numbers shown above the slider -->
        <div class="column is-full scale-question">
          <div class="scale-rating">
            <div class="" v-for="(value, index) in activeValues">
              <div :style="scaleRatingStyle(index, activeValues)" class="rate">
                <span class="value-rating" :class="{selectedValue: isSelected(index, activeValues)}" :style="valueBox" @click="selectValue(index+1, activeValues)">{{ value.rating }}</span>

              </div>
            </div>
          </div>

          <!-- The slider itself -->
          <Slider v-model="scaleAnswer" class="scale-slider" :step="(1/activeValues.length)*100" show-stops show-tip="never" @on-input="saveAnswer"></Slider>

          <!-- the optional labels shown below the slider -->
          <div class="scale-rating scale-text" v-if="questionData.question_type == 'select_rating_text'">
            <div class="" v-for="(value, index) in activeValues">
              <div :style="scaleRatingStyle(index, activeValues)" class="rate" v-if="value.status == true" >
                <!-- To prevent the value-text from overlapping it only should be shown when tht total number of avtiveValues is <= 5. Else, only show the first and last item of the values -->
                <span class="value-text" :class="{selectedValue: isSelected(index, activeValues)}" @click="selectValue(index+1, activeValues)" v-if="countTextValues(activeValues) <=5 || (countTextValues(activeValues)>5 && (index == 0 || index == activeValues.length-1))">{{ value.text }}</span>

              </div>

              <!-- <div :style="scaleRatingStyle(index, activeValues)" class="rate" v-if="value.status == true">
                <span class="value-text" :class="{selectedValue: isSelected(index, activeValues)}" @click="selectValue(index+1, activeValues)">{{ value.text }}</span>

              </div> -->
            </div>
          </div>

        </div>

        <!-- button area (right side of question card) -->
        <question-options v-if="questionData.comment==1"/>

      </div>

      <div v-if="(questionData.isDoesNotApply === '1' || questionData.isDoesNotApply === 1) && (questionData.question_type == 'select_rating' || questionData.question_type == 'select_rating_text')"
          style="padding: 20px 0 0 0">
          <p-check class="p-default p-curve p-fill p-smooth p-bigger is-size-5 p-icon" v-model="doesNotApply" @change="toggleDoesNotApply"><i class="icon fas fa-check check-icon" slot="extra"></i></p-check>
          <div style="margin: 10px 0 0 0; color:#9c9c9c">
            <p class="is-size-5 long-value" style="cursor: default">niet van toepassing</p>
          </div>
      </div>
    </div>

    <!-- Comment component to be redered when comments are allowed for this question -->
    <comment-box ref="commentBox" v-if="questionData.comment=='1'" />
  </section>
</template>

<script>
import QuestionHeader from './QuestionHeader'
import QuestionOptions from './QuestionOptions'
import CommentBox from './CommentBox'

export default {
  components: {
    'question-header': QuestionHeader,
    'question-options': QuestionOptions,
    'comment-box': CommentBox
  },
  props: {
    questionData: Object, // eslint-disable-line vue/require-default-prop
    number: Number // eslint-disable-line vue/require-default-prop
  },
  data () {
    return {
      scaleAnswer: 0,
      uploads: [],
      hover: null,
      comment: {
        showComment: false,
        commentFocussed: false,
        questionIsFocussed: false
      },
      doesNotApply: false
    }
  },
  mounted () {
    this.scaleAnswer = this.getSliderScore(this.questionData.answer, this.questionData.values)
  },
  methods: {
    toggleDoesNotApply(event) {
      this.doesNotApply = event;
      this.comment.showComment = true;
      this.scaleAnswer = 0;
      this.questionData.answer = undefined;
      this.questionData.doesNotApply = event;
    },
    saveAnswer () {
      let answer = this.getAbsoluteScore(this.scaleAnswer, this.questionData.values)
      // console.log('the answer:')
      // console.log(answer)
      this.questionData.answer = answer
      this.$store.commit('updateActivity', this.$store.getters.getActivities)
      // console.log(JSON.parse(localStorage.getItem('activities')))
    },
    scaleRatingStyle (index, values) {
      let length = this.getCountOfValues(values)
      let step = this.getStepFromIndex(index, values)
      let percentage = step / length * 100
      if (step === length) {
        percentage -= 2
      }
      let leftPercentage = percentage.toString()
      leftPercentage += '%'
      return {
        left: leftPercentage
      }
    },
    isSelected (index, values) {
      // let answer = value.rating*10
      let step = this.getStepFromIndex(index, values)
      let length = this.getCountOfValues(values)
      let score = this.getRelativeScore(step, length)
      // console.log(score)
      if (score === this.scaleAnswer) {
        // console.log(true)
        return true
      } else {
        return false
      }
    },
    getCountOfValues: (values) => {
      let count = 0
      values.forEach((value) => {
        if (value.status === true) {
          count++
        }
      })
      return count
    },
    getStepFromIndex (index, values) {
      let step = 0
      // let length = this.getCountOfValues(values)
      for (var i = 0; i < values.length; i++) {
        if (values[i].status === true && index != null) {
          step += 1
          // console.log(values[i])
          // console.log(values[index])
          // console.log(index)
          if (values[i].rating === values[index].rating) {
            // console.log(true)
            // console.log(step)
            return step
          }
        }
      }
      return step
    },
    getSliderScore (answer, values) {
      let index = null
      for (var i = 0; i < values.length; i++) {
        if (values[i].rating === answer) {
          index = i
          break
        }
      }
      let sliderScore = this.getStepFromIndex(index, values)
      return sliderScore / this.getCountOfValues(values) * 100
    },
    getRelativeScore (step, length) {
      return step / length * 100
    },
    getAbsoluteScore (answer, values) {
      let step = answer * this.getCountOfValues(values) / 100
      // console.log('ABSOLUTE STEP');
      // console.log(step)
      let current = 1
      for (var i = 0; i < values.length; i++) {
        if (values[i].status === true) {
          if (step === current) {
            // console.log('value.rating')
            // console.log(values[i].rating)
            // console.log(values[i])
            return values[i].rating
            break
          } else {
            current++
          }
        }
      }
    },
    selectValue (step, values) {
      if (this.doesNotApply) return;
      let score = this.getRelativeScore(step, values.length)
      this.scaleAnswer = score
    },
    countTextValues (values) {
      let count = 0;
      values.forEach(element => {
        if (element.text) count++;
      });
      return count;
    }
  },
  computed: {
    activeValues () {
      let result = this.questionData.values.filter(value => {
        return value.status === true
      })
      // console.log('Active scale values:');
      
      // console.log(result);
  
      return result
    },
    valueBox () {
      let width = 750/this.activeValues.length
      let marginLeft = 18 - width/2

      let style = {
        width: width + 'px',
        marginLeft: marginLeft + 'px'
      }
      
      return style
    }
  },
  provide () {
    return {
      question: this.questionData,
      number: this.number,
      comment: this.comment,
      uploads: this.uploads
    }
  }
}
</script>

<style scoped>

  .scale-question {
    padding-right: 80px;
  }
  .scale-rating {
    position: relative;
    height: 22px;
    padding-bottom: 35px;
    /* margin-left: 185px;
    margin-right: 22px; */
  }
  
  .scale-rating .rate {
    position: absolute;
    display: inline;
    margin-left: -20px;
  }

  .scale-text {
    width: 103%;
    margin-left: -25px;
  }

  /* .table-header .members {
    position: absolute;
    display: inline;
    left: 32%;
  }

  .table-header .status {
    position: absolute;
    display: inline;
    left: 53%;
  } */

  .radio-option {
    padding-bottom: 10px;
  }

  .radio-option-text {
    padding-left: 5px;
  }

  .value-text {
    text-align: center;
    position: absolute;
    font-weight: 500;
    font-size: 16px;
    color: #c9c9c9;
    max-width: 100px;
    cursor: pointer;
  }

  .value-rating {
    position: absolute;
    font-weight: 600;
    color: #d4d3d3;
    font-size: 33px;
    /* margin-left: -18px; */
    /* margin-right: 50px; */
    margin-top: -9px;
    cursor: pointer;
    text-align: center;
    /* width: 75px; */
    height: 150px;
    z-index: 11;
  }

  .selectedValue {
    color: #5f5e5e !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/ScaleQuestion.vue